"use strict";

require("core-js/modules/web.dom-collections.iterator.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CursorPagination", {
  enumerable: true,
  get: function () {
    return _CursorPagination.default;
  }
});
Object.defineProperty(exports, "Pagination", {
  enumerable: true,
  get: function () {
    return _Pagination2.default;
  }
});
exports.StyledPagination = void 0;
Object.defineProperty(exports, "usePagination", {
  enumerable: true,
  get: function () {
    return _Pagination3.default;
  }
});

var PaginationStyles = _interopRequireWildcard(require("./Pagination.styles"));

var _CursorPagination = _interopRequireDefault(require("./CursorPagination"));

var _Pagination2 = _interopRequireDefault(require("./Pagination"));

var _Pagination3 = _interopRequireDefault(require("./Pagination.hooks"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const StyledPagination = PaginationStyles;
exports.StyledPagination = StyledPagination;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTdHlsZWRQYWdpbmF0aW9uIiwiUGFnaW5hdGlvblN0eWxlcyJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1BhZ2luYXRpb24vaW5kZXgudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0ICogYXMgUGFnaW5hdGlvblN0eWxlcyBmcm9tICcuL1BhZ2luYXRpb24uc3R5bGVzJ1xuXG5leHBvcnQgeyBkZWZhdWx0IGFzIEN1cnNvclBhZ2luYXRpb24gfSBmcm9tICcuL0N1cnNvclBhZ2luYXRpb24nXG5leHBvcnQgeyBkZWZhdWx0IGFzIFBhZ2luYXRpb24gfSBmcm9tICcuL1BhZ2luYXRpb24nXG5leHBvcnQgeyBkZWZhdWx0IGFzIHVzZVBhZ2luYXRpb24gfSBmcm9tICcuL1BhZ2luYXRpb24uaG9va3MnXG5leHBvcnQgY29uc3QgU3R5bGVkUGFnaW5hdGlvbiA9IFBhZ2luYXRpb25TdHlsZXNcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQTs7QUFFQTs7QUFDQTs7QUFDQTs7Ozs7O0FBQ08sTUFBTUEsZ0JBQWdCLEdBQUdDLGdCQUF6QiJ9